var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('div',{attrs:{"id":"app"}},[(_vm.showNav)?_c('Navbar'):_vm._e(),_c('router-view')],1):_c('loading-overlay',{staticClass:"h-screen w-full",attrs:{"isLoading":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }